"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
require("./index.scss");
const FieldErrorSection_1 = require("@Components/Fields/FieldErrorSection");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const dayjs_1 = __importDefault(require("dayjs"));
class DatePickerComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "dateValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.value || null
        });
        Object.defineProperty(this, "activeInputState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "onChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                this.dateValue = e;
                this.props.onChange(e ? (0, dayjs_1.default)(e).format() : '', this.props.id);
                this.onBlurInput();
            }
        });
        Object.defineProperty(this, "onFocusInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.activeInputState = true;
            }
        });
        Object.defineProperty(this, "onBlurInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.activeInputState = false)
        });
        Object.defineProperty(this, "setDateInitValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.dateValue = value;
            }
        });
        (0, mobx_1.makeObservable)(this, {
            dateValue: mobx_1.observable,
            activeInputState: mobx_1.observable,
            onChange: mobx_1.action,
            onFocusInput: mobx_1.action,
            onBlurInput: mobx_1.action,
            setDateInitValue: mobx_1.action,
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== undefined) {
            this.setDateInitValue(this.props.value);
        }
    }
    render() {
        const { label, assistiveText, errorMessage, disabled, required, helperTitle, helperTitleText, helperType } = this.props;
        const classNames = [
            'input-text-component',
            'main-color-set',
            'datepicker-custom-component',
            this.activeInputState ? 'focused' : '',
            this.dateValue ? 'filled' : '',
            disabled ? 'disabled' : '',
            errorMessage ? 'error' : '',
        ]
            .join(' ')
            .trim();
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("label", null, label),
            helperTitleText && (helperTitle || helperType) && (react_1.default.createElement(CustomToolTip_1.default, { title: helperTitle, info: helperTitleText, type: helperType })),
            react_1.default.createElement(react_datepicker_1.default, { maxDate: this.props.maxDate ? this.props.maxDate : new Date('2100-12-31'), minDate: this.props.minDate ? this.props.minDate : new Date('1900-01-01'), showPopperArrow: false, dateFormat: 'MMMM d yyyy', selected: this.dateValue, onChange: this.onChange, onBlur: this.onBlurInput, onFocus: this.onFocusInput, peekNextMonth: true, showMonthDropdown: true, showYearDropdown: true, dropdownMode: "select", isClearable: true, disabled: disabled }),
            react_1.default.createElement(FieldErrorSection_1.FieldErrorSection, { errorMessage: errorMessage, assistiveText: assistiveText, required: required })));
    }
}
exports.default = (0, mobx_react_1.observer)(DatePickerComponent);
